import Excel from "exceljs";
import moment from "moment";
import _ from "lodash";
import { createProduct } from "@/fetch/fetchProduct";

export default function extractManningsData(e, productData) {
  return new Promise(async (resolve, reject) => {
    const wb = new Excel.Workbook();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.readAsArrayBuffer(file);
    let salesData = [];
    let productDataM18 = {};
    let notFounds = {};
    let error = [];
    //1 unique id = mannings code + date value
    //2 mannings code
    //3 product desc
    //4 date value
    //5 qty
    //6 category
    //7 unit price
    //8 selling price
    //9 total amount
    //10 Promotion
    //11 M18
    //13 Brnad
    const skuMapping = {
      937672: "HOL-CHC0060",
      "066555": "VEN-PRP0030",
      939207: "HOL-PRD0030",
      "066548": "VEN-BBP0030",
      123307: "VEN-ADP006",
      761916: "GER-BFQ0120",
      761940: "GER-STO0150",
      122465: "VEN-CPP0030",
      122457: "VEN-WCP0030",
      121327: "HOL-KGV0060",
      126649: "GER-IIC0030",
      763870: "RTN-NMN0060",
    };
    const brandMapping = {
      CHILDLIFE: 1,
      CLEVERIN: 2,
      IGGLOBE: 3,
      LIV7: 3,
      MCT: 3,
      GLQ10: 3,
      HOLDBODY: 4,
      JINTAN: 5,
      MYCOSAN: 6,
      PROTECA: 7,
      RETURN: 8,
      SHAO: 9,
      PROV: 10,
      PROVEN: 10,
      RESCUE: 11,
      BACH: 12,
      BETTERYOU: 13,
      LABNOVATION: 14,
      OMEGA: 15,
      SPATONE: 16,
    };
    let record = 1;

    // console.log("productData", productData);
    reader.onload = () => {
      const buffer = reader.result;
      try {
        wb.xlsx.load(buffer).then(async (workbook) => {
          const salesDataWorkSheet = workbook.getWorksheet(1);
          salesDataWorkSheet.eachRow((row, rowIndex) => {
            if (rowIndex >= 4) {
              const date = moment(row.values[5]);
              // console.log("row.values", row.values);
              if (date.isValid() && parseInt(row.values[3])) {
                const mannings_id = _.padStart(row.values[3], 6, "0");
                let m18_code = "";

                m18_code = productData[mannings_id]?.m18_product_code;

                if (m18_code === undefined) {
                  if (typeof row.values[11] === "object") {
                    if (
                      row.values[11].result?.error ||
                      row.values[11].result === undefined
                    ) {
                      m18_code = productData[mannings_id]?.m18_product_code;
                    } else {
                      m18_code = row.values[11].result;
                    }
                  } else if (!row.values[11] || row.values[11] === "0") {
                    m18_code = productData[mannings_id]?.m18_product_code;
                  } else {
                    m18_code = row.values[11];
                  }
                }
                if (m18_code === undefined) {
                  m18_code = skuMapping[mannings_id];
                }
                if (m18_code === undefined) {
                  m18_code = "notFound";
                }
                if (!productDataM18[m18_code]) {
                  productDataM18[m18_code] = new Set();
                }
                productDataM18[m18_code].add(mannings_id);
                if (!productData[mannings_id]) {
                  let brand =
                    notFounds[mannings_id]?.brand ?? row.values[13]?.result;
                  notFounds[mannings_id] = {
                    product_name: row.values[4],
                    mannings_product_code: mannings_id,
                    m18_product_code: m18_code === "notFound" ? null : m18_code,
                    product_unit_price: parseInt(row.values[7]),
                    brand_types_id: brandMapping[brand],
                    brand,
                    is_active: false,
                  };
                }
                if (productData[mannings_id]?.product_id) {
                  const tx_date = date.format("YYYY-MM-DD");
                  const record_id = `${mannings_id}${date.format("X")}`;
                  salesData.push({
                    tx_date: tx_date,
                    mannings_id: mannings_id,
                    product_id: productData[mannings_id]?.product_id,
                    qty: row.values[7],
                    selling_price: 0,
                    promotion: 0,
                    record_id,
                  });
                } else {
                  //console.log("mannings_id", mannings_id);
                }
                record++;
              }
            }
          });

          _.forEach(productDataM18.notFound, (d) => {
            _.forEach(productDataM18, (m18, key) => {
              if (m18.has(d) && key !== "notFound") {
                productDataM18.notFound.delete(d);
              }
            });
          });
          // console.log("productDataM18", productDataM18);
          // console.log("productDataM18", productDataM18.notFound);
          // console.log("notFound", notFounds);
          // for (const notFound in notFounds) {
          //   error.push({
          //     id: notFound,
          //     product_name: notFounds[notFound].product_name,
          //   });
          //   //await createProduct(notFounds[notFound]);
          // }
          console.log(salesData);
          if (!_.isEmpty(notFounds)) {
            reject({ message: "productNotExist", notFounds });
          }

          resolve(salesData);
        });
      } catch (err) {
        console.log(err);
      }
    };
  });
}
